import { appStore } from '~/mobx/appStore';

export const isFranchiseDisableByPos = (
  editableBranchId: number | undefined = undefined,
  editableBranchCreated: string | undefined = undefined
): boolean => {
  return editableBranchId === undefined || (appStore.isAddonsAvailable.franchise && editableBranchCreated === 'Taker');
};
